<template>
  <div class="obj-major-info-content config-info">
    <div class="title title-bar">구성 정보</div>
    <div class="config-content-wrapper">
      <div class="config-total">
        <span class="total">{{ objTotal }}</span>개의 장비 및 서비스
      </div>
      <div class="config-content">
        <div>
          <table class="list-info-double" v-show="!isOperActive">
            <tr v-for="oper in operationInfo" :key="oper.key">
              <th>{{ oper.label }}</th>
              <td class="list-value">{{ convertValue(configInfoData[oper.key], oper.key, oper.formatter) }}</td>
            </tr>
          </table>
        </div>
        <div class="config-chart">
          <w-common-chart ref="chart" :chart-type="'PIE'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WCommonChart from '@/views/topologymap/components/major-info/components/CommonChart';
import { OPERATION_INFO } from '@/constants/topologymap-major-info';
import { isEmpty, cloneDeep } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';


export default {
  name: 'WOtherObjectBasicInfoView',
  components: {
    WCommonChart,
  },
  props: {
    /**
     * 관리대상 정보
     * @type {Object}
     */
    objectInfo: {
      type: Object,
      default: () => {},
    },
    /**
     * 하위맵 여부
     * @type {Object}
     */
    isSubMap: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getValueAfterCheckEmpty,
      /**
       * 구성정보 표현 객체
       * @type {Object}
       */
      OPERATION_INFO,
      /**
       * 구성정보 데이터
       * @type {Object}
       */
      configInfoData: {},
      /**
       * 장비 및 데이터 토탈 값
       * @type {Number}
       */
      objTotal: 0,
      /**
       * 더보기 활성화 flag
       * @type {Boolean}
       */
      isOperActive: false,
    };
  },
  computed: {
    /**
     * 구성정보 표현 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    operationInfo() {
      let oper = [{ key: '', label: '' }];
      oper = OPERATION_INFO.SUBMAP.DEFAULT;
      return oper;
    },
  },
  methods: {
    /**
     * 더보기 활성화 변경 콜백
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onOperActive(value) {
      this.isOperActive = !isEmpty(value);
    },
    /**
     * 데이터 초기화(요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} configInfoData [description]
     */
    setData(configInfoData) {
      const data = cloneDeep(configInfoData);
      delete data.eventInfo;
      delete data.perfInfo;
      this.configInfoData = data;
      this.objTotal = data.objTotal;
      this.$refs.chart.setData(data.objList);
    },
    /**
     * 데이터 초기화(기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.configInfoData = {};
      this.objTotal = 0;
      this.isOperActive = false;
    },
    /**
     * 포매터에 따른 값 변환 함수
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value     [description]
     * @param  {[type]} key       [description]
     * @param  {[type]} formatter [description]
     * @return {[type]}           [description]
     */
    convertValue(value, key, formatter) {
      if (formatter === 'count') {
        return `${getValueAfterCheckEmpty(value)} 대`;
      }
      return getValueAfterCheckEmpty(value);
    },
    /**
     * String > Number 변환
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getStringtoNumber(value) {
      return value > 0 ? Number(value) : 0;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/OtherObjectBasicInfoView.vue